import { render, staticRenderFns } from "./DataPerformanceStandmans.vue?vue&type=template&id=4aec503a&scoped=true&"
import script from "./DataPerformanceStandmans.vue?vue&type=script&lang=ts&"
export * from "./DataPerformanceStandmans.vue?vue&type=script&lang=ts&"
import style0 from "./DataPerformanceStandmans.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataPerformanceStandmans.vue?vue&type=style&index=1&id=4aec503a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec503a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
